import script from "./OccupancyView.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupancyView.vue?vue&type=script&setup=true&lang=js"

import "./OccupancyView.vue?vue&type=style&index=0&id=36c8c83a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c8c83a"]])

export default __exports__